import { Line, getDatasetAtEvent } from 'react-chartjs-2';
import { FC, useRef } from 'react';
import { ChartData, ChartOptions, ScatterDataPoint } from 'chart.js';

export const ChartLine: FC<{
  title: string;
  isStackedX: boolean;
  isStackedY: boolean;
  isLinearX: boolean;
  legendKeysToIgnore: string[];
  xAxisTitle: string;
  yAxisTitle: string;
  data: ChartData<'line', (number | ScatterDataPoint | null)[], unknown>;
}> = ({
  title,
  isStackedX,
  isStackedY,
  isLinearX,
  legendKeysToIgnore,
  xAxisTitle,
  yAxisTitle,
  data
}: {
  title: string;
  isStackedX: boolean;
  isStackedY: boolean;
  isLinearX: boolean;
  legendKeysToIgnore: string[];
  xAxisTitle: string;
  yAxisTitle: string;
  data: ChartData<'line', (number | ScatterDataPoint | null)[], unknown>;
}) => {
  const chartRef = useRef<any>();

  const onClick = (e: any) => {
    console.log(e);
    console.log(getDatasetAtEvent(chartRef.current, e));
  };

  const options: ChartOptions<'line'> = {
    animation: false,
    normalized: true,
    parsing: false,
    elements: {
      point: {
        radius: 0
      }
    },
    plugins: {
      title: {
        display: title.length > 0,
        text: title,
        align: 'start',
        font: {
          weight: '700',
          size: 14
        }
      },
      legend: {
        position: 'top',
        align: 'end',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          boxHeight: 8,
          filter: (legendItem) => !legendKeysToIgnore.includes(legendItem.text)
        }
      },
      decimation: {
        enabled: true,
        algorithm: 'lttb',
        samples: 100
      }
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: isStackedX,
        type: isLinearX ? 'linear' : 'category',
        grid: {
          display: false
        }
      },
      xTitle: {
        type: 'category',
        axis: 'x',
        display: xAxisTitle.length > 0,
        border: {
          display: false
        },
        title: {
          align: 'center',
          text: xAxisTitle,
          display: true,
          font: {
            size: 12
          }
        }
      },
      y: {
        stacked: isStackedY
      },
      yTitle: {
        type: 'category',
        axis: 'y',
        display: yAxisTitle.length > 0,
        border: {
          display: false
        },
        title: {
          align: 'center',
          text: yAxisTitle,
          display: true,
          font: {
            size: 12
          }
        }
      }
    }
  };

  return (
    <Line ref={chartRef} options={options} data={data} onClick={onClick} />
  );
};
